import { toast } from "sonner";
import { updateEntity } from "./api";
import { useMutation } from "@tanstack/react-query";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
    const payload = {};
    if ("organisation" in values) {
        const orgValue = values.organisation;
        
        if (typeof orgValue === 'string') {
            payload.organisation = orgValue;
        } else if (orgValue?.id) {
            payload.organisation = orgValue.id;
        }
    }

    Object.entries(values).forEach(([key, value]) => {
        if (!["organisation"].includes(key)) {
            payload[key] = value;
        }
    });

    return payload;
}

export function useUpdateEntity() {
    return useMutation({
        mutationFn: async ({ entityId, values }) => {
            const payload = buildPayload(values);

            const response = await updateEntity({ entityId, item: payload });
            return response;
        },
        onSuccess: () => {
            toast.success("Entity Updated Successfully");
            invalidateAllQueries();
        },
        onError: (error) => {
            toast.error(error.message);
            console.log(error.message);
        },
    });
}
